import { render, staticRenderFns } from "./company.vue?vue&type=template&id=8a69ff56&scoped=true"
import script from "./company.vue?vue&type=script&lang=js"
export * from "./company.vue?vue&type=script&lang=js"
import style0 from "./company.vue?vue&type=style&index=0&id=8a69ff56&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"
import style1 from "./company.vue?vue&type=style&index=1&id=8a69ff56&prod&rel=stylesheet%2Fscss&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a69ff56",
  null
  
)

export default component.exports